__turbopack_context__.v({
  "arrow": "artwork-viewer-module-scss-module__nT-10G__arrow",
  "back": "artwork-viewer-module-scss-module__nT-10G__back",
  "close": "artwork-viewer-module-scss-module__nT-10G__close",
  "container": "artwork-viewer-module-scss-module__nT-10G__container",
  "forward": "artwork-viewer-module-scss-module__nT-10G__forward",
  "isDisabled": "artwork-viewer-module-scss-module__nT-10G__isDisabled",
  "isFullscreen": "artwork-viewer-module-scss-module__nT-10G__isFullscreen",
  "js-iv__trigger": "artwork-viewer-module-scss-module__nT-10G__js-iv__trigger",
});
